import React from "react";
import HeaderOne from "../components/header/HeaderOne";
import BannerOne from "../components/banner/BannerOne";
import AboutOne from "../components/about/AboutOne";
import ServiceOne from "../components/service/ServiceOne";
import BusinessGoalOne from "../components/businessgoal/BusinessGoalOne";
import Counterup from "../components/counterup/Counterup";
import GalleryOne from "../components/gallery/GalleryOne";
import BrandOne from "../components/brand/BrandOne";
import TeamOne from "../components/team/TeamOne";
import Feature from "../components/feature/Feature";
import TestimonialOne from "../components/testimonials/TestimonialOne";
import BlogOne from "../components/blog/BlogOne";
import ContactForm from "../components/contactform/ContactForm";
import MapOne from "../components/map/MapOne";
import FooterOne from "../components/footer/FooterOne";
import PopupBanner from "../components/popup/PopupBanner";

function HomeOne() {
  return (
    <div>
      <PopupBanner />
      <HeaderOne />
      <BannerOne />
      <Counterup />
      <AboutOne />

      <FooterOne />
    </div>
  );
}

export default HomeOne;
